import { ChevronRight, Medal } from "lucide-react";


const getMedalType = (score: number, allScores: number[]): string | null => {
  const uniqueScores = [...new Set(allScores)].sort((a, b) => b - a);
  const scoreRank = uniqueScores.indexOf(score);

  if (scoreRank === 0) return "text-yellow-400"; // Gold
  if (scoreRank === 1) return "text-gray-400"; // Silver
  if (scoreRank === 2) return "text-amber-600"; // Bronze
  return null;
};



export const TeamDataRow = ({
  team,
  index,
  navigate,
  allScores,
}: {
  team: any;
  index: number;
  navigate: any;
  allScores: number[];
}) => {
  const medalType = getMedalType(team.totalScore, allScores);

  return (
    <tr
      key={team.teamId}
      className={`hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer leaderboard-item transition-colors duration-200`}
      onClick={() => {
        const currentPath = window.location.pathname;
        if (currentPath.startsWith("/currentSeason")) {
          navigate(`/currentSeason/leaderboard/team/${team.teamId}`);
        } else {
          navigate(`/leaderboard/team/${team.teamId}`);
        }
      }}
    >
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          {medalType && <Medal className={`w-5 h-5 ${medalType}`} />}
          <span className="ml-1 text-gray-900 dark:text-white">
            {index + 1}
          </span>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          {team.teamLogo && (
            <img
              src={`/api/static/images/${team.teamLogo}`}
              alt={team.teamName}
              className="w-8 h-8 rounded-full mr-3"
            />
          )}
          <div>
            <div className="text-sm font-medium text-gray-900 dark:text-white">
              {team.teamName}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">
              {team.groupName}
            </div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
        {team.totalScore}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right">
        <ChevronRight className="w-5 h-5 text-green-600" />
      </td>
    </tr>
  );
};
